import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Métadonnées par route. Met à jour le <title>, <meta description>,
// la balise canonical et l'og:url côté client. C'est imparfait pour les
// crawlers (le SSR ferait mieux), mais Google rend désormais le JS, donc
// ça améliore le SEO immédiat sans alourdir la stack.

const SITE_URL = "https://lapetitelunetterie.fr";
const DEFAULTS = {
    title: "La Petite Lunetterie · Opticienne indépendante à Bourg-en-Bresse",
    description:
        "Boutique d'opticien indépendante à Bourg-en-Bresse, place Edgar Quinet. Sélection pointue de montures françaises et créateurs, examens de vue, conseils sur mesure et entretien à vie. Tenue par Sylvie depuis 2018.",
};

const ROUTES = {
    "/": DEFAULTS,
    "/montures": {
        title: "Nos montures · La Petite Lunetterie",
        description:
            "Découvrez notre sélection de montures françaises et créateurs : Naoned, Lunor, Anne et Valentin, OPS! Objects, Vinylize… Coup de cœur du moment et collection complète chez votre opticien à Bourg-en-Bresse.",
    },
    "/services": {
        title: "Nos services · La Petite Lunetterie",
        description:
            "Examen de vue, montage sur mesure, traitements premium, entretien à vie, conseil personnalisé : tous nos services chez votre opticien indépendant de Bourg-en-Bresse.",
    },
    "/contact": {
        title: "Nous trouver · La Petite Lunetterie",
        description:
            "Venez nous rencontrer au 7 place Edgar Quinet à Bourg-en-Bresse. Horaires, plan, email contact@lapetitelunetterie.fr — votre opticien indépendant Sylvie vous accueille.",
    },
    "/mentions-legales": {
        title: "Mentions légales · La Petite Lunetterie",
        description:
            "Mentions légales de La Petite Lunetterie, opticien indépendant à Bourg-en-Bresse.",
    },
    "/politique-de-confidentialite": {
        title: "Politique de confidentialité · La Petite Lunetterie",
        description:
            "Politique de confidentialité et gestion des données personnelles de La Petite Lunetterie.",
    },
};

function setMeta(name, content, attr = "name") {
    if (!content) return;
    let el = document.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function setLink(rel, href) {
    let el = document.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

export default function DocumentHead() {
    const { pathname } = useLocation();
    useEffect(() => {
        // /admin et /admin/login : on indique noindex (page privée)
        const isAdmin = pathname.startsWith("/admin");
        const meta = ROUTES[pathname] || DEFAULTS;
        document.title = meta.title;
        setMeta("description", meta.description);
        setMeta("robots", isAdmin ? "noindex,nofollow" : "index,follow");
        setLink("canonical", `${SITE_URL}${pathname === "/" ? "/" : pathname}`);
        setMeta("og:title", meta.title, "property");
        setMeta("og:description", meta.description, "property");
        setMeta("og:url", `${SITE_URL}${pathname}`, "property");
    }, [pathname]);
    return null;
}
